
const retry3Codes = ["Could not negotiate with SignalR Service:", "Failed to fetch"];

export {retry3Codes}